export default __webpack_public_path__ + "static/media/recordself.ba28ad72.png";